import React, { useState } from "react"
import { CustomModalBox } from "../modal/CustomModalBox"
import { Col, Row } from "react-bootstrap"
import { useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import {
  addNoteForEnrolmentCancelled,
  updateEnrolmentAction,
} from "../../pages/enrolment/enrolmentAction"
import pdfApi from "../../apis/pdfApi"
import { toast } from "react-toastify"

export const UpdateEnrolment = () => {
  const dispatch = useDispatch()
  const { _id } = useParams()
  const { user } = useSelector((state) => state.user)
  const { enrollments } = useSelector((state) => state.enroll)
  const enrolment = enrollments.find((enrollment) => enrollment._id === _id)

  const params = new URLSearchParams()
  params.set("location", user?.branch)
  const par = params.toString()

  const [userProfile, setUserProfile] = useState(enrolment)

  const handleOnChange = (e) => {
    const { name, value } = e.target

    setUserProfile({
      ...userProfile,
      [name]: value,
    })
  }

  const handleOnSubmit = (e) => {
    e.preventDefault()

    const { fName, lName, email, mobile, progress } = userProfile

    if (
      enrolment.fName !== userProfile.fName ||
      enrolment.lName !== userProfile.lName ||
      enrolment.email !== userProfile.email ||
      enrolment.mobile !== userProfile.mobile ||
      enrolment.progress !== userProfile.progress
    ) {
      if (window.confirm("Are you sure you want to update this enrolment?")) {
        const update = { fName, lName, mobile, email, progress }

        if (progress === "cancelled") {
          dispatch(
            updateEnrolmentAction(_id, {
              ...enrolment,
              params: par,
              progress: "cancelled",
              status: false,
              payment: {
                paidFull: false,
                paidDate: new Date(),
                status: "cancelled",
                installment: [...enrolment?.payment?.installment],
              },
            })
          ) &&
            dispatch(
              addNoteForEnrolmentCancelled({
                _id,
                params: par,
                message: "Enrolment cancelled",
              })
            )
        }

        if (progress === "complete") {
          const generateCertificate = async () => {
            const { fName, lName, course, _id } = userProfile
            const data = { fName, lName, course, _id }

            const res = await pdfApi.fetchPDF(data)
            if (res.status === "success") {
              toast.success(res.message)
            }
          }
          generateCertificate()
        }

        dispatch(updateEnrolmentAction(_id, { ...update, params: par }))
      }
      return
    }

    return alert("No information has been changed")
  }

  return (
    <CustomModalBox title="Update enrolment">
      <form className="enrol-form" onSubmit={handleOnSubmit}>
        <div className="form-row">
          <Row>
            <Col md="6">
              <label htmlFor="fName">First Name</label>
              <input
                type="text"
                id="fName"
                name="fName"
                placeholder="First Name"
                className="form-control mt-2"
                value={userProfile.fName}
                onChange={handleOnChange}
              />
            </Col>
            <Col md="6">
              <label htmlFor="lName">Last Name</label>
              <input
                type="text"
                id="lName"
                name="lName"
                placeholder="Last Name"
                className="form-control mt-2"
                value={userProfile.lName}
                onChange={handleOnChange}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <div>
                <label htmlFor="mobile">Mobile</label>
                <input
                  type="Number"
                  id="mobile"
                  name="mobile"
                  placeholder="Mobile"
                  className="form-control mt-2"
                  value={userProfile.mobile}
                  onChange={handleOnChange}
                />
              </div>
            </Col>

            <Col md="6">
              <div>
                <label htmlFor="email">Email</label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  placeholder="Email"
                  className="form-control mt-2"
                  value={userProfile.email}
                  onChange={handleOnChange}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <div>
                <select
                  name="progress"
                  id="progress"
                  className="form-control mt-2"
                  defaultValue={userProfile.progress}
                  onChange={(e) =>
                    setUserProfile({
                      ...userProfile,
                      progress: e.target.value,
                    })
                  }
                >
                  <option value="">----- Course Status -----</option>
                  <option value="ongoing">Ongoing</option>
                  <option value="complete">Complete</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
            </Col>
          </Row>
        </div>

        <button type="submit" className="enrol-btn">
          UPDATE
        </button>
      </form>
    </CustomModalBox>
  )
}
